<script lang='ts' setup>
const { theme } = useAppConfig()
</script>

<template>
  <div class="h-full overflow-auto relative" v-cloak>
    <header class="pos-sticky top-0 z-2">
      <slot name="header">
      </slot>
    </header>
    <main class="w-1200px mx-auto">
      <slot />
    </main>
    <footer>
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<style lang='scss' scoped>
header,
footer {
  background: transparent;
}
</style>
